import styled from 'styled-components';

import { breakpoints } from '../../constants';

export const ListWrapper = styled.ul`
    display: flex;
    overflow-x: scroll;
    scrollbar-width: none;
    padding: 0 10px;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (${breakpoints.mediumMin}) {
        overflow-x: hidden;
        padding: 0 20px;
        justify-content: center;
    }
`;
